import * as React from "react";
import type { Column } from "@tanstack/react-table";
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

/** A TanStack column header that toggles its sort, with the direction arrow. */
function SortableHeader<TData>({
  column,
  children,
}: {
  column: Column<TData, unknown>;
  children: React.ReactNode;
}) {
  const sorted = column.getIsSorted();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ml-3 h-7 gap-0.5"
      onClick={() => column.toggleSorting(sorted === "asc")}
    >
      {children}
      {sorted === "asc" ? (
        <ArrowUpIcon className="ml-1 size-3.25" />
      ) : sorted === "desc" ? (
        <ArrowDownIcon className="ml-1 size-3.25" />
      ) : (
        <ArrowUpDownIcon className="ml-1 size-3.25 opacity-50" />
      )}
    </Button>
  );
}

export { SortableHeader };
